<template>
  <div class="well col-md-5 pull-right">
    <label class="title" v-if="title"><h5 class="no-margin">{{title}}</h5></label>
    <br />
    <label class="item-label">Your Name</label>
    <div class="item">{{$user.$.name}}</div>
    
    <label class="item-label">Email</label>
    <div class="item">{{$user.email}}</div>

    <label class="item-label">Date</label>
    <div class="item">{{today}}</div>
  </div>
</template>

<script>
  export default {
    props: {
      title: String
    },

    computed: {
      today() { return global.moment(new Date()).format(global.app.$user.sessionSettings.DateAndTimeFormats.MomentDateFormat) }
    }
  }
</script>

<style lang="scss" scoped>
  @import "~@/assets/sass/_variables.scss";

  .well {
    padding: 2px 8px;
    border-radius: 0;
    box-shadow: none;
    @include theme {
      border-color: v(border);
    }
  }

  .item-label {
    vertical-align: middle;
  }

  .item {
    vertical-align: middle;
    max-width: 100%;
    padding-right: 10px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding-bottom: 4px;

    @include theme {
      color: v(ink);
      font-size: $font-size-small;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/_modules/Dashboard/widgets/ApprovalNeeded/user-info.vue